// removed by extract-text-webpack-plugin
module.exports = {"huanye":"qK4nUW7W4inznfuunHuj0","go":"_1Cs8sBw_-4Qd1U8aGRD7zk","col_bl":"_2JvaNdA1361qyzUwwkH_mz","triangle_border_left":"_3m8z98agVBbLO4rXE2NLGS","triangle_border_right":"w07Z2GiAvABgcV0RKsj4o","tra_a":"_9_kXCE6zyHue8ZKQp9hCu","tra_b":"_2VfR1nsRzTQlFEJ-wW8QL5","font_b":"_365Ph4iw1eEpD2GVf0zxCY","component":"_3xePkmgkBl_hpSoKiNwkNd","pagination":"_24xvpFyIf8H42vc-vJmL75","active":"_1pwLSaVrYjX2uVLlQMZzc4"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HomePagingBar/HomePagingBar.scss
 ** module id = 981
 ** module chunks = 0
 **/